import createConfigurableObject from '../../../utils/configurationObject';

export default (app) => {
    app.routes = app.routes || createConfigurableObject();
};
